import React, { useMemo } from 'react';

import { FormControl, FormControlLabel, FormHelperText, FormLabel, Radio, RadioGroup, useTheme } from '@mui/material';
import { ErrorMessage, Field, getIn } from 'formik';
import _ from 'lodash';

export const CustomRadioGroup = ({ value, options, label, disabled, onChange, booleanOptions = true }) => {

    const randomId = useMemo(() => _.uniqueId('custom-radio-group-'), []);

    return (
        <FormControl fullWidth disabled={ disabled }>
            <FormLabel
                id={ randomId }
                sx={ {
                    fontSize: '0.8rem',
                    color: 'text.secondary',
                    mb: 0.5
                } }
            >
                { label }
            </FormLabel>
            <RadioGroup
                row
                aria-labelledby={ randomId }
                value={ value }
                onChange={ (_, value) => onChange && onChange(booleanOptions ? value === 'true' : value) }>
                {
                    options?.map((option) => (
                        <FormControlLabel
                            key={ option?.label }
                            value={ option?.value }
                            label={ option?.label }
                            control={ <Radio size="small"/> }
                        />
                    ))
                }
            </RadioGroup>
        </FormControl>
    );
};

const RadioGroupFormik = ({ name, options, label, disabled, onChange, booleanOptions = true }) => {

    const randomId = useMemo(() => _.uniqueId('formik-radio-group-'), []);
    const theme = useTheme();

    return (
        <Field name={ name } type="radios">
            { ({ field: { value }, form: { errors, setFieldValue } }) => (
                <FormControl fullWidth disabled={ disabled } required>
                    <FormLabel
                        id={ randomId }
                        sx={ {
                            fontSize: '0.9rem',
                            color: !!getIn(errors, name) ? 'error.main' : 'text.primary',
                            mb: 0.5
                        } }
                    >
                        { label }
                    </FormLabel>
                    <RadioGroup
                        row
                        aria-labelledby={ randomId }
                        value={ value }
                        name={ name }
                        onChange={ (_, value) => {
                            setFieldValue(name, booleanOptions ? value === 'true' : value);
                            onChange && onChange(booleanOptions ? value === 'true' : value);
                        } }>
                        {
                            options?.map((option) => (
                                <FormControlLabel
                                    key={ option?.label }
                                    value={ option?.value }
                                    label={ option?.label }
                                    control={
                                        <Radio
                                            size="small"
                                            sx={ !!getIn(errors, name) ? { color: `${ theme.palette.error.main }` } : {} }
                                        />
                                    }
                                />
                            ))
                        }
                    </RadioGroup>
                    <FormHelperText error sx={ { mx: 0 } }>
                        <ErrorMessage name={ name }/>
                    </FormHelperText>
                </FormControl>
            ) }
        </Field>
    );
};

export default RadioGroupFormik;